import { IFileGateway, IJobGateway, JobInput, PresenterFunc } from '../interface';
import { Job } from '../entity';
import { Fragment, UpdaterFunc } from '../interface/common';
import {from} from 'apollo-link';

export class JobService {
  constructor(
    private readonly fileGateway: IFileGateway,
    private readonly jobGateway: IJobGateway,
  ) { }

  public async createJob(
    input: JobInput,
    file: File | null,
    presenter: PresenterFunc<Job | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    presenter(null, null, true);

    try {
      if (file) {
        const uploadItem = await this.jobGateway.getJobCsvUploadUrl();

        await this.fileGateway.upload(file, uploadItem.uploadUrl, 'text/csv');
        input.csvFileUri = uploadItem.fileUri;
      }

      const result = await this.jobGateway.createJob(input, fragment, updater);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }

  public async removeJob(
    id: string,
    presenter: PresenterFunc<Job | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
    refetchQueries?: string[],
  ) {
    presenter(null, null, true);

    try {
      const result = await this.jobGateway.removeJob(id, fragment, updater, refetchQueries);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }

  public async getImages(
      id: string,
      fromEmail: string,
      presenter: PresenterFunc<boolean | null>,
  ) {
    try {
      const result = await this.jobGateway.getJobImages(id, fromEmail);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }
}
